import jsonp from "jsonp";
import env from "../tools/Environment";

const isIframe = () => {
  return window.top !== window;
};
export default function checkSdc(from = "") {
  const url = from ? env.getUrls().sdc + encodeURIComponent(from) : env.getUrls().sdc;
  if (isIframe()) {
    console.info("checkSdc: iframe context");
    window.location = url;
    return new Promise(() => {});
  } else {
    return new Promise(resolve => {
      jsonp(url, { param: "JSONP_call", timeout: 1800 }, (err, sdc_response) => {
        if (err) {
          console.info("JSONP error");
          console.info(err);
        }
        resolve(sdc_response);
      });
    });
  }
}
